// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a-video__wrapper{width:100%;position:relative;overflow:hidden;background:#000}.a-video__wrapper .a-video__iframe{position:absolute;top:0;left:0;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
